// extracted by mini-css-extract-plugin
export default {"scanBtn":"scanButton_scanBtn__yer3D"};